<template>
  <div>
    <!-- <p class="c-inner-title">分组管理</p> -->
    <div class="auto">
      <page-title title="短链接" icon="fa-cog"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="18">
              <el-button type="primary" size="small" @click="handle">新增短链接</el-button>
            </el-col>
            <el-col :span="6" class="alignR">
              <el-select v-model="filter.group_id" placeholder="选择分类" size="small" @change="handleChangeFilter">
                <el-option key="" label="全部" value=""></el-option>
                <el-option
                  v-for="item in groupType"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column
              prop="name"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="group_name"
              label="分组">
            </el-table-column>
            <el-table-column
              prop="url"
              label="原始链接">
            </el-table-column>
            <el-table-column
              prop="rd_url"
              label="短链接">
            </el-table-column>
            <el-table-column
              prop="source"
              label="来源">
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="160">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button @click="editHandle(scope.row)" type="primary" size="small">修改信息</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="isAdd ? '新增短链接' : '修改短链接'" :modal-append-to-body="false" @close="handleExit" v-loading="submitloading" :visible.sync="formVisible">
      <el-form ref="form" :rules="rules" :model="form" label-width="100px" size="small">
        <el-form-item prop="name" label="名称">
          <el-input v-model.trim="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item prop="url" label="原始链接" v-show="isAdd">
          <el-input v-model.trim="form.url" placeholder="请输入原始链接"></el-input>
        </el-form-item>
        <el-form-item prop="group_id" label="分组类型" v-show="isAdd">
          <el-select v-model="form.group_id" placeholder="请选择分组">
            <el-option
              v-for="item in groupType"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit('form')">提交</el-button>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {Track} from '@/model'
export default {
  data () {
    return {
      tableData: [],
      groupType: [],
      isAdd: true,
      form: {
        id: '',
        name: '',
        url: '',
        group_id: ''
      },
      rules: {
        name: [
          { required: true, message: '名称不能为空！', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '原始链接不能为空！', trigger: 'blur' }
        ],
        group_id: [
          { required: true, message: '请选择分组！', trigger: 'blur' }
        ]
      },
      formVisible: false,
      codeVisible: false,
      loading: false,
      submitloading: false,
      tokenCode: '',
      type: '',
      formClone: {},
      btnLoading: false,
      pageSize: 50,
      currentPage: 0,
      totalData: [],
      filter: {
        group_id: '',
        page: '1',
        limit: '20'
      },
      total: 0
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    handleChangeFilter () {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/setting/track/shortlink', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getGroup()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    async getGroup () {
      this.loading = true
      let res = await Track.getSorturlList(this.filter)
      this.loading = false
      if (res !== false && !res['err_code']) {
        this.tableData = res['data'].list
        this.total = res['data'].total
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async getGroupType () {
      let res = await Track.group({
        type: 'shorturl',
        page: 1,
        limit: 99999
      })
      if (res !== false && !res['err_code']) {
        let groupType = []
        for (let k in res['data']['data']['list']) {
          let item = res['data']['data']['list'][k]
          let obj = {
            type: item.id,
            name: item.name
          }
          groupType.push(obj)
        }
        this.groupType = groupType
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    handle (index) {
      this.isAdd = true
      this.formVisible = true
      this.form = {
        id: '',
        name: '',
        url: '',
        group_id: ''
      }
    },
    editHandle (row) {
      console.log(row)
      this.isAdd = false
      this.formVisible = true
      this.form = {
        id: row.id,
        name: row.name,
        url: row.url,
        group_id: row.group_id
      }
    },
    async handleSubmit (formName) {
      this.submitloading = true
      this.$refs[formName].validate(async (valid) => {
        if (valid && this.form.name.trim()) {
          this.btnLoading = true
          let res = await Track.saveSortUrl(this.form)
          this.btnLoading = false
          if (res !== false && !res['err_code']) {
            this.$message.success('提交成功!')
            this.$refs[formName].clearValidate()
            this.formVisible = false
            this.resetFilter()
            this.getGroup()
          } else {
            this.$message.error(res['err_msg'])
          }
        }
      })
      this.submitloading = false
    },
    handleExit () {
      this.formVisible = false
      this.$refs['form'].clearValidate()
    }
  },
  created () {
    this.formClone = this.form
    this.queryToFilter()
    this.getGroupType()
  }
}
</script>
